import * as _uuid from "uuid";

export const uuid = _uuid.v4;

/**
 * This accepts a spread of input strings and uses them to derive a
 * new UUID. The UUID is guaranteed to be the same for the same input
 * strings, but different for different input strings.
 */
export function deriveUUID(...input: string[]) {
  const combined = input.sort().join("");

  return _uuid.v5(combined, UUID_NAMESPACE);
}

// Important! `deriveUUID` is intended to be a pure function. It returns a deterministic
// value given the input. This allows multiple clients to derive the same UUID when
// appropriate. Changing this namespace value will break existing UUIDs.
const UUID_NAMESPACE = "2ac01d6b-180b-49b3-9bcc-c9ce1af42afc";

export const isUuid = (value: string) => _uuid.validate(value);
